module.exports = require("ramda/src/objOf");